import React from "react";
import {Button, Icon, message, notification, Spin, Tooltip} from "antd";
import {getAuthHeader} from "../utils/security";
import {urlPath} from "./Settings";

export const checkMaxFileSize = (files, maxSize) => {
    for (let i = 0; i < files.length; i++) {
        const currentFile = files[i];
        const fileSize = currentFile.size / 1024 / 1024;
        if (fileSize > maxSize) {
            return false;
        }
    }
    return true;
};

export const handleGoBack = (val) => {
    if (val) {
        let browserUrl = new URL(window.location.href);
        browserUrl = browserUrl.href;
        const backUrl = browserUrl.replace("mode=details", "");
        window.location.href = backUrl;
    }
};

export const DownloadButton = (props) => {
    const downloadButtonStyles = {
        border: "1px solid",
        borderTop: "none",
        borderBottom: "none",
        borderRadius: 0,
        borderColor: "#eee",
        fontSize: "16px",
    };

    return (
        <Tooltip placement="bottom" title={props.text}>
            <Button
                data-translationkey={props.langkey}
                style={downloadButtonStyles}
                onClick={props.onClick}
            >
                <Icon type={props.type} />
            </Button>
        </Tooltip>
    );
};

export const downloadAd = (admaterialId, e) => {
    fetch(urlPath + "/api/downloadmaterial?admaterial=" + admaterialId, {
        credentials: "include",
        headers: getAuthHeader(),
    })
        .then((response) => response.text())
        .then((data) => {
            //console.log(data);
            //document.getElementById("downloadElem." + admaterialId).setAttribute('href' , data);
            //document.getElementById("downloadElem." + admaterialId).click();
            var win = window.open(data, "_blank");
            win.focus();
        })
        .catch((e) => console.error("Cannot download ad", e));
    e.stopPropagation();
};

export const Preloader = (props) => {
    return (
        <div id="preloaderContainer" data-visible={props.visible}>
            <p>{props.text}</p>
            <div style="display:none" id="preloader" />
            <Spin />
        </div>
    );
};

export const setInitialBodyZoom = (props) => {
    document.body.style.zoom = 1;
    const tableOpenWidth = () => {
        const tables = document.body.querySelectorAll("table");
        for (let i = 0; i < tables.length; i++) {
            //const tableWidth = tables[i].offsetWidth;
            let tableWidth = tables[i].getBoundingClientRect();
            tableWidth = tableWidth.width;
            if (tableWidth > 0) return tableWidth;
        }
        //return null;
    };
    const tableWidth = tableOpenWidth();
    const bodyWidth = window.innerWidth;
    if (tableWidth /* && false */) {
        const bodyZoom = parseFloat(document.body.style.zoom);
        const initialZoom =
            tableWidth * bodyZoom > bodyWidth
                ? (bodyWidth - 50) / tableWidth
                : bodyZoom;
        document.body.style.zoom = initialZoom;
    }

    const ixReport = document.getElementById("ixReport");
    if (ixReport) {
        const navTabParent = document.getElementsByClassName(
            "ant-tabs-nav-scroll"
        )[0];
        const navTab = document.getElementsByClassName("ant-tabs-nav")[0];
        ixReport.classList.remove("tabs-block-style");
        if (navTabParent && navTab) {
            if (navTabParent.offsetWidth <= navTab.offsetWidth) {
                ixReport.classList.add("tabs-block-style");
            } else {
                ixReport.classList.remove("tabs-block-style");
            }
        }
    }
};

export const Notification = (title, description, placement, buttonText) => {
    notification.open({
        message: title,
        description: description,
        placement: placement,
        btn: (
            <Button type="primary" onClick={() => notification.destroy()}>
                {buttonText}
            </Button>
        ),
    });
};

export const Message = (text, type) => {
    if (type === "loading") message.loading(text);
    else if (type === "destroy") message.destroy();
    else message.info(text);
};

export const relativePathRegexp = (url) => {
    return url.replace(/^(?:\/\/|[^\/]+)*\//, "/");
};

export const highlightMaterial = (id) => {
    const materialRow = document.getElementsByClassName("AdMaterial_" + id)[0];
    const creativeRows = document.getElementsByClassName("creativeRow");
    for (let i = 0; i < creativeRows.length; i++) {
        creativeRows[i].classList.remove("row-highlighted");
    }
    if (materialRow) materialRow.classList.add("row-highlighted");
};

export const copyToClipboard = (e) => {
    const input = e.target
        .closest(".ant-input-group")
        .querySelectorAll("input")[0];
    if (!input.value || input.value.length === 0)
        input.value = input.getAttribute("placeholder");
    input.select();
    document.execCommand("copy");
    //Message("Copied", "info");
};

export const getBookingUrl = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const dataParam = urlParams.get("data");
    const matspecParam = urlParams.get("matspec");
    const matspecNameParam = urlParams.get("matspecname");
    let loadbookingUrl = null;
    if (dataParam)
        loadbookingUrl = urlPath + "/api/noauth/loadbooking?data=" + dataParam;
    else if (matspecParam)
        loadbookingUrl = urlPath + "/api/loadbooking?matspec=" + matspecParam;
    else if (matspecNameParam) {
        const systemidParam = urlParams.get("systemid");
        loadbookingUrl = urlPath + "/api/loadbooking_matspecname?matspec=" + matspecNameParam + (systemidParam? "&systemid=" + systemidParam: "");
    }
    return loadbookingUrl + "&timezone=" + Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const formatDate = (date) => {
    var monthNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
    ];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    const curHour =
        date.getHours() > 12
            ? date.getHours() - 12
            : date.getHours() < 10
            ? "0" + date.getHours()
            : date.getHours();
    const curMinute =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

    console.log(
        "Formatting date: ",
        day +
            " " +
            monthNames[monthIndex] +
            " " +
            year +
            " " +
            curHour +
            ":" +
            curMinute
    );
    return (
        day +
        " " +
        monthNames[monthIndex] +
        " " +
        year +
        " " +
        curHour +
        ":" +
        curMinute
    );
};

export const setTableFieldPairs = (
    fields,
    fieldTranslations,
    source,
    childSource
) => {
    const getPair = (field, prefix, source) => {
        let prop = field.replace(prefix, "");
        const getVal = (source, prop) => {
            let val = source[prop];
            if (prefix === "MaterialSpecification." && childSource) {
                val = childSource && childSource[prop];
            }
            if (prefix === "Insertion.") val = source.insertions[0][prop];
            if (typeof val === "object") return getVal(val, prop);
            return val;
        };
        const val = getVal(source, prop);
        if (prefix === "MaterialSpecification.")
            prop =
                fieldTranslations["Job.matspec:MaterialSpecification." + prop];
        if (prefix === "AdMaterial.")
            prop = fieldTranslations["Job.admaterial:AdMaterial." + prop];
        if (prefix === "Insertion.")
            prop = fieldTranslations["Job.insertion:Insertion." + prop];
        return { prop, val };
    };
    const data = fields.map((field) => {
        if (field.startsWith("MaterialSpecification.")) {
            return getPair(field, "MaterialSpecification.", source);
        }
        if (field.startsWith("AdMaterial.")) {
            return getPair(field, "AdMaterial.", source);
        }
        if (field.startsWith("Insertion.")) {
            return getPair(field, "Insertion.", source);
        }
        return { prop: field, val: null };
    });
    return data;
};

export const getParamFromUrl = (url, param) => {
    const searchParams = new URLSearchParams(url);
    const val = searchParams.get(param);
    if (val) return val;
    return null;
};

var dropZone = document.body;

dropZone.addEventListener("dragover", function(event) {
    event.preventDefault();
    event.dataTransfer.dropEffect = "none";
});

dropZone.addEventListener("drop", function(event) {
    event.preventDefault();
});

export const updateProofLink = async (admaterialId, url) => {
    const proofLinkAnchor = document.getElementById("proofLinkAnchor");
    if (proofLinkAnchor) {
        proofLinkAnchor.setAttribute("href", url);
        proofLinkAnchor.classList.remove("d-none");
        proofLinkAnchor.classList.add("proof-link");
    }
    const response = await fetch(
        urlPath +
            "/api/prooflink?admaterial=" +
            admaterialId +
            "&url=" +
            encodeURIComponent(url),
        { method: "PATCH", credentials: "include", headers: getAuthHeader() }
    );
    await response.json();
};

export const setCurrentVersion = async (matspec, admaterial) => {
    const response = await fetch(
        urlPath +
            "/api/currentversion?matspec=" +
            matspec +
            "&currentmaterial=" +
            admaterial,
        {
            method: "PUT",
            credentials: "include",
            headers: getAuthHeader(),
        }
    );
    await response.json();
};

export const saveAudit = (matspec, action) => {
    fetch(urlPath + "/api/saveaudit?action=" + action + "&matspec=" + matspec, {
        method: "POST",
        credentials: "include",
        headers: getAuthHeader(),
    })
        .then((response) => {
            console.log("Submitted audit", response.text());
        })
        .catch((e) => console.error("Cannot submit audit", e));
};

export const changeStatus = async (matspec, status) => {
    await fetch(
        urlPath + "/api/changestatus?matspec=" + matspec + "&status=" + status,
        {
            method: "PUT",
            credentials: "include",
            headers: getAuthHeader(),
        }
    )
        .then((response) => {
            console.log("Submitted status", response.text());
        })
        .catch((e) => console.error("Cannot submit status", e));
};

export const processPartyTag = async (
    value,
    matspecId,
    admaterialId,
    sgCode
) => {
    //console.log("3rd party tag processing", matspecId, value);
    let valueFormat = value.toString();
    valueFormat = valueFormat.replace(/“/g, '"').replace(/”/g, '"');
    const response = await fetch(
        urlPath +
            "/api/upload3partytag?content=" +
            btoa(unescape(encodeURIComponent(valueFormat))) +
            "&matspec=" +
            matspecId +
            (admaterialId > 0 ? "&admaterial=" + admaterialId : "") +
            "&thumbnailsize=50" +
            "&timezone=" +
            Intl.DateTimeFormat().resolvedOptions().timeZone +
            (sgCode ? "&sgcode=" + value : ""),
        { method: "POST", credentials: "include", headers: getAuthHeader() }
    );
    const data = response.json();
    //console.log(data);
};

export const removeDuplicatedFromArray = (array) => {
    const uniqueSet = new Set(array);
    const uniqueArray = [...uniqueSet];
    return uniqueArray;
};

window.onscroll = function() {
    // Get the header
    var element = document.getElementById("matspecFilterTabs");
    // Get the offset position of the navbar
    if (element) {
        var sticky = element.offsetTop;
        stickyFn(element, sticky);
    }
};

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function stickyFn(element, sticky) {
    if (element && window.pageYOffset > sticky) {
        element.classList.add("sticky");
    } else {
        element.classList.remove("sticky");
    }
}

const checkValidUrl = (url, admaterial) => {
    const pattern = /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-\/]))?/;
    const target = document.getElementById("validPartyTagUrl" + admaterial);
    if (!target) return true;
    if (!pattern.test(url) && url !== "") {
        target.classList.remove("d-none");
        target.classList.add("error-msg");
        console.log("Please enter a valid URL.");
        return false;
    } else {
        target.classList.add("d-none");
        target.classList.remove("error-msg");
        return true;
    }
};
export const admaterialUpdateHelper = (params) => {
    //const target = e.target;
    const { target, admaterial, field, value, matspecId } = params;
    console.log("updating");
    for (let _ in params) {
        const targetValid = "field-valid";
        const targetInvalid = "field-invalid";
        console.log(params[_].value)
        if (!params[_].admaterial || params[_].admaterial < 1) {
            console.error("Wrong AdMaterial." + [_].admaterial);
        } else {
            let url =
                "/api/admaterialupdate?admaterial=" +
                params[_].admaterial +
                "&" +
                params[_].field +
                "=" +
                encodeURIComponent(params[_].value);
            if (params[_].matspecId) url += "&matspec=" + params[_].matspecId;
            fetch(urlPath + url, {
                method: "PUT",
                credentials: "include",
                headers: getAuthHeader(),
            })
                .then((response) => response.json())
                .then((data) => {
                    console.log(
                        "AdMaterial." + params[_].admaterial + " update:",
                        params[_].field + "=" + params[_].value,
                        data
                    );
                    target.classList.add(targetValid);
                })
                .catch((e) => console.error("Cannot update material", e));
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/Helpers.js